import { cn } from "../../utils/cn";

interface VendorAvatarProps {
  name: string;
  className?: string;
  textClassName?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";
  imageUrl?: string | null;
}

// 세모 보라 계열 — 사람마다 밝기만 달리한다
const COLORS = ["#B48DE6", "#C4A3EE", "#A98BDB", "#9B7BD4"];

// 사이즈별 크기 및 폰트 매핑
const SIZE_CONFIGS = {
  xs: {
    container: "w-6 h-6",
    text: "text-2xs",
  },
  sm: {
    container: "w-8 h-8",
    text: "text-xs",
  },
  md: {
    container: "w-10 h-10",
    text: "text-sm",
  },
  lg: {
    container: "w-12 h-12",
    text: "text-base",
  },
  xl: {
    container: "w-16 h-16",
    text: "text-xl",
  },
  "2xl": {
    container: "w-20 h-20",
    text: "text-2xl",
  },
  "3xl": {
    container: "w-24 h-24",
    text: "text-3xl",
  },
};

export function VendorAvatar({
  name,
  className,
  textClassName,
  size,
  imageUrl,
}: VendorAvatarProps) {
  // 이미지 URL이 있으면 이미지로 표시
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={name}
        className={cn("w-full h-full object-cover", className)}
      />
    );
  }

  const safeName = name.trim() || "?";
  const firstChar = safeName.charAt(0);
  const isDefaultSupplier = /^공급사\s*#/.test(safeName);

  // Simple hash for color consistency
  const colorIndex =
    safeName.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
    COLORS.length;
  const bgColor = COLORS[colorIndex];

  // className이 있으면 사이즈 무시 (기존 호환성), 없으면 size 사용
  const sizeConfig = size && !className ? SIZE_CONFIGS[size] : null;

  // className에서 text-* 클래스 추출
  const extractedTextClass = className?.match(/text-\[[\d]+px\]|text-\w+/)?.[0];

  return (
    <div
      className={cn(
        "flex items-center justify-center text-white font-semibold overflow-hidden",
        sizeConfig?.container,
        className,
      )}
      style={{ backgroundColor: bgColor }}
    >
      <span
        className={cn(
          "flex items-center justify-center w-full h-full",
          !isDefaultSupplier &&
            (textClassName ??
              extractedTextClass ??
              sizeConfig?.text ??
              "text-2xs"),
        )}
        style={
          isDefaultSupplier ? { padding: "17px 19px", gap: "10px" } : undefined
        }
      >
        {isDefaultSupplier ? (
          <svg
            width="16.176"
            height="21.029"
            viewBox="0 0 19 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: "16.176px", height: "21.029px" }}
            className="flex-shrink-0"
          >
            <path
              d="M4.23529 5.85294H7.47059M4.23529 11.5147H13.9412M4.23529 14.75H13.9412M4.23529 17.9853H7.47059M2.61765 22.0294H15.5588C15.9878 22.0294 16.3993 21.859 16.7027 21.5556C17.006 21.2522 17.1765 20.8408 17.1765 20.4118V2.61765C17.1765 2.18862 17.006 1.77717 16.7027 1.4738C16.3993 1.17043 15.9878 1 15.5588 1H2.61765C2.18862 1 1.77717 1.17043 1.4738 1.4738C1.17043 1.77717 1 2.18862 1 2.61765V20.4118C1 20.8408 1.17043 21.2522 1.4738 21.5556C1.77717 21.859 2.18862 22.0294 2.61765 22.0294Z"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          firstChar
        )}
      </span>
    </div>
  );
}
